<template>
  <a id="dlink">
    <v-tooltip bottom>
      <v-btn
        slot="activator"
        text-color="white"
        class="d-inline-block bg_white custom_pos_excell"
        @click.native="setPositionMenu($event)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="customIcon i_header"
          version="1.1"
          viewBox="0 0 24 24"
        >
          <path
            d="M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M17,11H13V13H14L12,14.67L10,13H11V11H7V13H8L11,15.5L8,18H7V20H11V18H10L12,16.33L14,18H13V20H17V18H16L13,15.5L16,13H17V11Z"
          ></path>
        </svg>

        <small>Exportar para excel</small>
      </v-btn>
      <span>Exportar a tabela para o formato .xls</span>
    </v-tooltip>

    <v-menu
      v-model="menu"
      nudge-top="20"
      :position-x="menuX"
      :position-y="menuY"
      :close-on-content-click="true"
      bottom
      offset-y
    >
      <v-list id="options">
        <div id="title">Opções de exportação</div>

        <v-list-tile
          class="item"
          v-for="(item, index) in getOpcoesMenu"
          :key="index"
          style="cursor: pointer;"
        >
          <v-list-tile-title @click="setDownload(item.evento)">
            <v-tooltip right>
              <div slot="activator">
                <svg
                  v-if="item.icon == 'selected'"
                  data-v-1ab5010e
                  viewBox="0 0 24 24"
                  style="width: 16px;height: 17px;margin-bottom: -4px;"
                >
                  <path
                    data-v-1ab5010e
                    fill="#808080"
                    d="M20,16V10H22V16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z"
                  ></path>
                </svg>
                <v-icon v-else style="font-size: 15px;">{{item.icon}}</v-icon>
                {{ item.title }}
              </div>

              <span>{{item.tooltip}}</span>
            </v-tooltip>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </a>
</template>

<script>
import { findTributacao, findSimples } from "@/domain/notas/nfse/util";
export default {
  props: ["component", "table", "nfseErros", "nfseDes"],
  data: () => ({
    dialog: false,
    menu: false,
    menuX: 0,
    menuY: 0,
    items: [
      {
        title: "Exportação completa",
        tooltip: "Exportar todos os itens da tabela.",
        icon: "done_all",
        evento: "all"
      },
    ],
    objExpSelected: {
      title: "Exportação selecionada",
      tooltip: `Exportar apenas os itens que foram selecionados da tabela.`,
      icon: "selected",
      evento: "selected"
    }
  }),
  computed: {
    getOpcoesMenu: function() {
      if(!this.nfseErros && !this.nfseDes){
        this.items.push(
          {
            title: "Exportação parcial",
            tooltip: "Exportar apenas os itens exibidos da tabela.",
            icon: "adjust",
            evento: "parce"
          }
        )
      }
      if (this.component.enable.selectAll && !this.nfseErros && !this.nfseDes) {
        this.items.push(this.objExpSelected);
      }
      return this.items;
    }
  },
  methods: {
    setPositionMenu: function(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    setDownload(evento) {
      switch (evento) {
        case "all":
          this.exportExcel(1);
          break;
        case "parce":
          this.exportExcel(2);
          break;
        case "selected":
          this.exportExcel(3);
          break;
      }
    },
    exportExcel: async function(tipo) {
      try {
        var tab_text = '<table border="1px" style="text-align: center;">';
        var textRange;
        if(this.nfseErros){
          var tab = document.querySelector("#tableErros table");
        }else if(this.nfseDes) {
          var tab = document.querySelector("#tableDes table");
        }else {
          var tab = document.querySelector("#table table");
        }
        var lines;
        let arrayNotas;
        let pos;
        if (tipo == 1) {
          lines = this.table.array_todas_notas.length;
          arrayNotas = this.table.array_todas_notas;
          pos = 0;
        } else if (tipo == 2) {
          arrayNotas = this.table.arrayNotas;
          pos =
            this.table.pagination.page * this.table.pagination.rowsPerPage -
            this.table.pagination.rowsPerPage;
          lines = pos + this.table.pagination.rowsPerPage;
        } else if (tipo == 3) {
          arrayNotas = this.table.selected;
          lines = this.table.selected.length;
          pos = 0;
        }
        var idHeaders = [];

        var b = document.createElement("a");
        b.style = "display:none";
        document.body.appendChild(b);

        // header da tabela
        if (lines > 0) {
          var header = "";
          for (var i = 0; i < tab.rows[0].cells.length; i++) {
            if (
              (tab.rows[0].cells[i].outerHTML.indexOf("display: none;") == -1 &&
                tab.rows[0].cells[i].outerHTML.indexOf("acoes") == -1 &&
                tab.rows[0].cells[i].outerHTML.indexOf("slctBox") == -1 &&
                tab.rows[0].cells[i].outerHTML.indexOf("auxFix") == -1) ||
              tab.rows[0].cells[i].outerHTML.indexOf("h_arrayEmpresas") != -1 ||
              tab.rows[0].cells[i].outerHTML.indexOf("h_rela_arrayLogins") != -1
            ) {
              // debugger;
              header =
                header + "<th>" + tab.rows[0].cells[i].innerHTML + "</th>";
              idHeaders.push(tab.rows[0].cells[i].id.replace(/h_/gi, ""));
            }
          }
          if(this.nfseErros) {
            idHeaders = ["cnpj", "razao", "erro", "vlEnviado", "discriminacao"];
          }
          if(this.nfseDes) {
            idHeaders = ["cnpj", "razao", "numeroNfse", "vlEnviado", "dtEmissao"];
          }
          let titleExcel = this.component.textPlural;
          let downName =
            this.component.name.charAt(0).toUpperCase() +
            this.component.name.slice(1);
          if (
            this.component.name == "NFeRecebidas" &&
            this.component.tipo == "recebida"
          ) {
            titleExcel = "Nota Fiscal Eletrônica(NF-e) Recebidas";
            downName = "NFeRecebidas";
          } else if (
            this.component.name == "NFeRecebidas" &&
            this.component.tipo == "emitida"
          ) {
            titleExcel = "Nota Fiscal Eletrônica(NF-e) Emitidas";
            downName = "NFeEmitidas";
          }

          if (
            this.component.name == "NFSE" &&
            this.component.tipo == "recebida"
          ) {
            titleExcel = this.nfseDes ? "Inconsistencia DES" : "Nota Fiscal de Serviço Eletrônica(NF-e) - Recebidas";
            downName = this.nfseDes ? "Inconsistencia DES" : "NFseRecebidas";
          } else if (
            this.component.name == "NFSE" &&
            this.component.tipo == "emitida"
          ) {
            titleExcel = this.nfseErros ? "Erros Nota Fiscal de Serviço Eletrônica(NF-e) - Emitidas" : "Nota Fiscal de Serviço Eletrônica(NF-e) - Emitidas";
            downName = this.nfseErros ? "ErrosNFseEmitidas" : "NFseEmitidas";
          }
          if (
            this.component.name == "produtos" &&
            this.component.tipo == "recebida"
          ) {
            titleExcel = "Produtos de Entrada";
            downName = "ProdutosEntrada";
          } else if (
            this.component.name == "produtos" &&
            this.component.tipo == "emitida"
          ) {
            titleExcel = "Produtos de Saída";
            downName = "ProdutosSaida";
          } else if (this.component.name == "usuario") {
            titleExcel = "Colaboradores";
            downName = "Colaboradores";
          } else {
            downName = downName + ".xls";
          }
          tab_text =
            tab_text +
            "<b>" +
            titleExcel +
            "</b>" +
            '<tr bgcolor="#32a3d5" color: white;">' +
            header +
            "</tr>";
          b.download = downName;
        }
        //corpo da tabela
        for (pos; pos < lines; pos++) {
          var linhas = "";
          for (var prop in arrayNotas[pos]) {
            if (idHeaders.indexOf(prop) != -1) {
              if (
                prop.toLowerCase().indexOf("valor") != -1 ||
                prop.toLowerCase().indexOf("vlr") != -1
              ) {
                let vlr = " ";
                if (arrayNotas[pos][prop] != undefined) {
                  vlr +=
                    "R$ " +
                    arrayNotas[pos][prop].toLocaleString("pt-BR", {
                      minimumFractionDigits: 2
                    });
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' +
                  vlr +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("validade") != -1) {
                let data = "";
                if (arrayNotas[pos][prop].data != undefined) {
                  data = arrayNotas[pos][prop].data.toLocaleDateString();
                } else {
                  data = arrayNotas[pos][prop];
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                  data +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("opcaosimples") != -1) {
                await findSimples(arrayNotas[pos][prop])
                  .then(simples => {
                    return simples;
                  })
                  .then(simples => {
                    if(simples) {
                    linhas =
                      linhas +
                      '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                      simples.tipo +
                      " - " +
                      simples.desc +
                      "</td>";
                    }else {
                      linhas =
                        linhas +
                        '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                        ''
                        +
                        "</td>";
                    }
                  });
              } else if (prop.toLowerCase().indexOf("tribnfe") != -1) {
                await findTributacao(arrayNotas[pos][prop])
                  .then(trib => {
                    return trib;
                  })
                  .then(trib => {
                    if(trib) {
                    linhas =
                      linhas +
                      '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                      trib.tipo +
                      " - " +
                      trib.desc +
                      "</td>";
                    }else {
                      linhas =
                        linhas +
                        '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                        ''
                        +
                        "</td>";
                    }
                  });
              } else if (
                prop.toLowerCase().indexOf("emissao") != -1 ||
                prop.toLowerCase().indexOf("dt") != -1
              ) {
                let data = " ";
                if (
                  arrayNotas[pos][prop] &&
                  arrayNotas[pos][prop] != undefined
                ) {
                  if (
                    arrayNotas[pos][prop] instanceof Date &&
                    !isNaN(arrayNotas[pos][prop])
                  ) {
                    data = arrayNotas[pos][prop].toLocaleDateString();
                  } else {
                    data = arrayNotas[pos][prop];
                  }
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                  data +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("custom") != -1) {
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' +
                  arrayNotas[pos][prop].value +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("statusin") != -1) {
                let status = "";
                if (
                  (arrayNotas[pos].preCadastro == undefined &&
                    arrayNotas[pos][prop]) ||
                  (arrayNotas[pos][prop] &&
                    arrayNotas[pos].preCadastro.length == 0)
                ) {
                  status = "Ativo";
                } else if (
                  arrayNotas[pos] &&
                  arrayNotas[pos].preCadastro != undefined &&
                  arrayNotas[pos].preCadastro.length > 0
                ) {
                  status = "Pendente";
                } else if (
                  arrayNotas[pos][prop] != undefined &&
                  !arrayNotas[pos][prop]
                ) {
                  status = "Inativo";
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black;text-align: center;">' +
                  status +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("issretido") != -1) {
                let issRetido = "Não";
                if (arrayNotas[pos][prop] == "true") {
                  issRetido = "Sim";
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' +
                  issRetido +
                  "</td>";
              } else if (
                prop.toLowerCase().indexOf("xprod") != -1 ||
                prop.toLowerCase().indexOf("cprod") != -1 ||
                prop.toLowerCase().indexOf("fornrazao") != -1 ||
                prop.toLowerCase().indexOf("xnome") != -1 ||
                prop.toLowerCase().indexOf("xfant") != -1
              ) {
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: left;">' +
                  arrayNotas[pos][prop] +
                  "</td>";
              } else if (
                prop.toLowerCase().indexOf("produto") != -1 ||
                prop.toLowerCase().indexOf("colaboradores") != -1
              ) {
                let prodLength = 0;
                if (arrayNotas[pos][prop] != undefined) {
                  prodLength = arrayNotas[pos][prop].length;
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' +
                  prodLength +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("certificado") != -1) {
                let possuiCert = 'Pendente';
                if(arrayNotas[pos][prop] !== undefined && arrayNotas[pos][prop].validade && arrayNotas[pos][prop].validade.data) {
                  possuiCert = arrayNotas[pos][prop].validade.data.toLocaleDateString('pt-BR', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second:'2-digit'});
                }
                // let possuiCert = "Não";
                // if (arrayNotas[pos][prop] != undefined) {
                //   possuiCert = "Sim";
                // }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' +
                  possuiCert +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("enderEmit") != -1) {
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' +
                  "<table><thead><th>Endereço</th><th>CEP</th></thead><tbody>" +
                  "<tr><td>" +
                  arrayNotas[pos][prop].xLgr +
                  ", " +
                  arrayNotas[pos][prop].nro +
                  "</td><td>" +
                  arrayNotas[pos][prop].CEP +
                  "</td><tr/>" +
                  "</table>";
                ("</td>");
              } else if (
                prop.toLowerCase().indexOf("cnpj") != -1 ||
                prop.toLowerCase().indexOf("cpf") != -1
              ) {
                if (arrayNotas[pos][prop] != undefined) {
                  if (arrayNotas[pos][prop].length == 11) {
                    linhas =
                      linhas +
                      '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                      arrayNotas[pos][prop].replace(
                        /^(\d{3})(\d{3})(\d{3})(\d{2})/,
                        "$1.$2.$3-$4"
                      ) +
                      "</td>";
                  } else {
                    linhas =
                      linhas +
                      '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                      arrayNotas[pos][prop].replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                        "$1.$2.$3/$4-$5"
                      ) +
                      "</td>";
                  }
                } else {
                  linhas =
                    linhas +
                    '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">' +
                    "" +
                    "</td>";
                }
              } else if (prop.toLowerCase().indexOf("vinculo") != -1) {
                let item = "";
                var arrayCte = arrayNotas[pos]["cte"];
                var arrayCce = arrayNotas[pos]["xmlCce"];
                var arrayNfe = arrayNotas[pos]["nfe"];
                var formatTabela = [];
                if (
                  (!arrayNfe || arrayNfe && arrayNfe.length == 0) &&
                  (!arrayCte || arrayCte && arrayCte.length == 0) &&
                  (!arrayCce || arrayCce && arrayCce.length == 0)
                ) {
                  item = "Não possui vínculo";
                }
                
                // console.log(arrayCte[0])
                if (arrayCte && arrayCte.length > 0) {
                  let chaves = "";
                  if(arrayCte.chave) {
                    arrayCte.forEach(
                      item => (chaves += item.chave.toString() + " " + "\n")
                    );
                  } else {
                    arrayCte.forEach(
                      item => (chaves += item.toString() + " " + "\n")
                    );
                  }

                  let obj = { tipo: "CTE", vlr: chaves };
                  formatTabela.push(obj);
                }
                if (arrayNfe && arrayNfe.length > 0) {
                  let chaves = "";
                  arrayNfe.forEach(
                    item => (chaves += item.toString() + " " + "\n")
                  );
                  // console.log(chaves)

                  let obj = { tipo: "NFE", vlr: chaves };
                  formatTabela.push(obj);
                }
                if (arrayCce && arrayCce.length > 0) {
                  let obj = {
                    tipo: "CCE",
                    vlr: `Quantidade: ${arrayCce.length}`
                  };
                  formatTabela.push(obj);
                }
                if (formatTabela.length > 0) {
                  item =
                    "<table><thead><th>Tipo</th><th>Informação</th></thead><tbody>";
                  formatTabela.forEach(v => {
                    item +=
                      '<tr style="vertical-align: middle;"><td>' +
                      v.tipo +
                      '</td><td style="text-align: center;">' +
                      `${v.vlr}` +
                      "</td><tr/>";
                  });
                  item += "</table>";
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: center;width:400px">' +
                  item +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("duplicata") != -1) {
                var arrayVenc = arrayNotas[pos][prop];
                var item = "";
                if (!arrayVenc || arrayVenc && arrayVenc.length == 0) {
                  item = "Não informada";
                } else if (arrayVenc.length == 1) {
                  item = arrayVenc[0].dVenc
                    .substring(0, arrayVenc[0].dVenc.indexOf("T"))
                    .split("-")
                    .reverse()
                    .join("/");
                } else {
                  item +=
                    "<table><thead><th>parcelas</th><th>valor</th></thead><tbody>";
                  arrayVenc.forEach(v => {
                    item +=
                      "<tr><td>" +
                      v.dVenc
                        .substring(0, v.dVenc.indexOf("T"))
                        .split("-")
                        .reverse()
                        .join("/") +
                      "</td><td>" +
                      v.vDup.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) +
                      "</td><tr/>";
                  });
                  item += "</table>";
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style=" color: black; text-align: right;">' +
                  item +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("rela_arraylogins") != -1) {
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style="vertical-align: middle; color: black; text-align: right;">';
                if (arrayNotas[pos][prop].length > 0) {
                  linhas =
                    linhas +
                    "<table><thead><th>Datas</th><th>Horários</th></thead><tbody>";
                  for (let i = 0; i < arrayNotas[pos][prop].length; i++) {
                    linhas =
                      linhas +
                      "<tr><td>";
                      if (
                      new Date(arrayNotas[pos][prop][i]) instanceof Date &&
                      !isNaN(new Date(arrayNotas[pos][prop][i]))
                    ) {
                      linhas =
                        linhas +
                        new Date(arrayNotas[pos][prop][
                          i
                        ]).toLocaleDateString() +
                        "</td><td>" + new Date(arrayNotas[pos][prop][
                          i
                        ]).toLocaleTimeString() + "</td>";
                    }

                  }
                  linhas = linhas + "<tbody>" + "</table>" + "</td>";
                } else {
                  linhas = linhas + "Sem Acessos" + "</td>";
                }

              } else if (prop.toLowerCase().indexOf("arrayempresas") != -1) {
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style="vertical-align: middle; color: black; text-align: right;">';
                if (arrayNotas[pos][prop].length > 0) {
                  linhas =
                    linhas +
                    "<table><thead><th>CNPJ/CPF</th><th>RAZÃO</th><th>Data Cadastro</th><th>NF-e</th><th>CT-e</th><th>NFS-e</th></thead><tbody>";
                  for (let i = 0; i < arrayNotas[pos][prop].length; i++) {
                    linhas =
                      linhas +
                      "<tr><td>" +
                      (arrayNotas[pos][prop][i].empresa.cnpj != undefined
                        ? arrayNotas[pos][prop][i].empresa.cnpj.length > 11
                          ? arrayNotas[pos][prop][i].empresa.cnpj.replace(
                              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                              "$1.$2.$3/$4-$5"
                            )
                          : arrayNotas[pos][prop][i].empresa.cnpj.replace(
                              /^(\d{3})(\d{3})(\d{3})(\d)/,
                              "$1.$2.$3-$4"
                            )
                        : "") +
                      " " +
                      "</td><td>" +
                      arrayNotas[pos][prop][i].empresa.razao +
                      "</td><td>";
                    if (
                      new Date(arrayNotas[pos][prop][i].empresa.dtReg) instanceof Date &&
                      !isNaN(new Date(arrayNotas[pos][prop][i].empresa.dtReg))
                    ) {
                      linhas =
                        linhas +
                        new Date(arrayNotas[pos][prop][
                          i
                        ].empresa.dtReg).toLocaleDateString() +
                        "</td>";
                    } else {
                      linhas =
                        linhas +
                        arrayNotas[pos][prop][i].empresa.dtReg +
                        "</td>";
                    }
                    linhas =
                      linhas +
                      "<td>" +
                      (arrayNotas[pos][prop][i].empresa.nfe_recebida +
                        arrayNotas[pos][prop][i].empresa.nfe_emitida) +
                      "</td><td>" +
                      (arrayNotas[pos][prop][i].empresa.cte_tomada +
                        arrayNotas[pos][prop][i].empresa.cte_nao_tomada) +
                      "</td><td>" +
                      (arrayNotas[pos][prop][i].empresa.nfse_recebida +
                        arrayNotas[pos][prop][i].empresa.nfse_emitida) +
                      "</td><tr/>";
                  }
                  linhas = linhas + "<tbody>" + "</table>" + "</td>";
                } else {
                  linhas = linhas + "Sem empresas" + "</td>";
                }
              } else if (prop.toLowerCase().indexOf("rela_plano") != -1) {
                let text_planos = "";
                if (arrayNotas[pos][prop]) {
                  switch (arrayNotas[pos][prop].toLowerCase()) {
                    case "super":
                      text_planos = "Super";
                      break;
                    case "gestao":
                      text_planos = "Gestão";
                      break;
                    case "performance":
                      text_planos = "Performance";
                      break;
                    case "micro":
                      text_planos = "Micro";
                      break;
                    default:
                      text_planos = arrayNotas[pos][prop];
                  }
                }
                linhas =
                  linhas +
                  '<td bgcolor="#f5f5f5" style="vertical-align: middle; color: black; text-align: center;">' +
                  text_planos +
                  "</td>";
              } else if (prop.toLowerCase().indexOf("chave") != -1) {
                let item = "";
                if (arrayNotas[pos][prop] != undefined) {
                  item = arrayNotas[pos][prop];
                }
                linhas =
                  linhas +
                  `<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">
                  '${item}
                  </td>`;
              } else if (prop.toLowerCase().indexOf("emitIe") != -1) {
                let item = "";
                if (arrayNotas[pos][prop] != undefined) {
                  item = arrayNotas[pos][prop];
                }
                linhas =
                  linhas +
                  `<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">
                  '${item}
                  </td>`;
              } else {
                let item = "";
                if (arrayNotas[pos][prop] != undefined) {
                  item = arrayNotas[pos][prop].toString();
                }
                linhas =
                  linhas +
                  `<td bgcolor="#f5f5f5" style=" color: black; text-align: center;">
                  ${item}
                  </td>`;
              }
            }
          }
          if (linhas.length > 0) {
            tab_text = tab_text + "<tr>" + linhas + "</tr>";
          }
        }
        tab_text = tab_text + "</table>";
        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
        tab_text = tab_text.replace(/<img[^>]*>/gi, "");
        tab_text = tab_text.replace(/arrow_upward/gi, "");
        tab_text = tab_text.replace(/help/gi, "");
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        var data_type = "data:application/vnd.ms-excel;base64,",
          template =
            '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
          base64 = function(s) {
            return window.btoa(unescape(encodeURIComponent(s)));
          },
          format = function(s, c) {
            return s.replace(/{(\w+)}/g, function(m, p) {
              return c[p];
            });
          };
        var ctx = {
          worksheet: "Sheet 1" || "Worksheet",
          table: tab_text
        };

        var blob = new Blob(["\ufeff"+tab_text], {
          type: "application/vnd.ms-excel;charset=UTF-8",
          encoding: "UTF-8"
        });
        var downloadUrl = URL.createObjectURL(blob);

        b.href = downloadUrl;
        b.click();
        window.URL.revokeObjectURL(downloadUrl);
        b.remove();
      } catch (err) {
        console.log(`Ocorreu algum erro ao exportar para excell ${err}`);
      }
    },
    str2bytes(str) {
      var bytes = new Uint8Array(str.length);
      for (var i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i);
      }
      return bytes;
    }
  }
};
</script>
<style scoped>
.lista-colunas {
  width: 46%;
  margin: 0 2% 0 0;
}
.lista-colunas ul {
  height: 40vh;
  list-style-type: none;
  overflow: auto;
}
#colItensAtivas i {
  transform: rotateY(180deg);
}
#title {
  font-size: 10px;
  cursor: default;
  text-align: center;
  text-transform: uppercase;
  font-weight: 800;
  padding: 6px;
  font-family: "Quicksand", sans-serif;
  color: #25476a;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnExpExcell/BtnExpExcell.vue